import PropTypes from 'prop-types';
import { Fragment, ReactElement, useState } from 'react';
import SearchBox from '../../../../../components/Form/SearchBox/SearchBox';
import { LABEL_POSITIONS } from '../../../../../components/Form/_constants';
import { Subtitle1 } from '../../../../../components/UI/MDC/Typography/Typography';
import { CSS_CLASSES, FORM_KEYS } from '../../_constants';
import { getDepartmentIds, getDepartmentUnit } from './_api';

import * as classes from '../../Agreements.module.scss';

/**
 * Create contextualized textbox for alternate email address
 * @param {*} properties needed by departmentSearchBox including and limited to handleChange()
 * @returns {ReactElement} Alternate Email Address Form Group
 */
const DepartmentSearchBox = ({
	labelPosition = LABEL_POSITIONS.TOP,
	handleChange = LABEL_POSITIONS.TOP,
	required = true,
	setDepartmentId,
	touched,
}) => {
	const [departmentIdOptions, setDepartmentIdOptions] = useState([]);
	const [sBusinessUnit, setBusinessUnit] = useState();
	const [sCustomError, setCustomError] = useState('');

	return (
		<Fragment>
			<SearchBox
				autoComplete='off'
				labelPosition={
					labelPosition ? labelPosition : LABEL_POSITIONS.TOP
				}
				inputProps={{ customError: sCustomError, required: required }}
				label='Department ID'
				name={FORM_KEYS.DEPARTMENT_ID}
				type='text'
				options={departmentIdOptions}
				onSearch={value => {
					// Update departmentIdOptions with data from DB
					getDepartmentIds(value).then(payload =>
						setDepartmentIdOptions(payload)
					);

					// Reset selected departmentId
					setDepartmentId('');
				}}
				onChange={e => {
					handleChange(e);

					getDepartmentUnit(e.target.value).then(payload => {
						if (
							payload &&
							payload.length === 1 &&
							departmentIdOptions.includes(e.target.value)
						) {
							handleChange({
								target: {
									name: FORM_KEYS.DEPARTMENT_UNIT,
									value: payload[0],
								},
							});
							setBusinessUnit(payload[0]);

							// Set departmentId
							setDepartmentId(e.target.value);
						}
					});
				}}
				validate={value => {
					let errorMessage;
					if (required && touched) {
						if (!departmentIdOptions.includes(value)) {
							errorMessage = 'Please select a valid department.';
						}
						setCustomError(errorMessage ? errorMessage : '');
					}
					return errorMessage;
				}}
			/>
			{sBusinessUnit ? (
				<Subtitle1
					name={FORM_KEYS.DEPARTMENT_UNIT}
					className={classes[CSS_CLASSES.LABEL_AGREEMENT_TEXT]}
				>
					Business Unit: {sBusinessUnit}
				</Subtitle1>
			) : null}
		</Fragment>
	);
};

DepartmentSearchBox.propTypes = {
	handleChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
};

export { DepartmentSearchBox };
